/**
 * API Configuration
 * Central configuration for all API requests
 */

// Get the API base URL from environment variable
// In production: https://api.creolecentric.com
// In development: http://localhost:8000
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';

/**
 * Helper function to construct API URLs
 * @param {string} path - API path starting with /v1/
 * @returns {string} - Full API URL
 */
export function getApiUrl(path) {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
}

export default {
  API_BASE_URL,
  getApiUrl,
};
